const ErrorHandler = ({ error, resetError }) => {
  // Auto-reload if chunk load error
  if (
    error.message?.includes("Loading chunk") ||
    error.message?.includes("Failed to fetch dynamically imported module")
  ) {
    console.warn("🔁 Reloading due to chunk load error");
    window.location.reload();
    return;
  }

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        gap: 10,
        justifyContent: "center",
        alignItems: "center",
        width: "100%",
      }}
    >
      <p style={{ textAlign: "center" }}>{error.message}</p>
      <button onClick={resetError}>Try again</button>
    </div>
  );
};

export default ErrorHandler;
